import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormROValueWithTooltip from '../../../library/form/components/FormROValueWithTooltip';
import FormLink from '../../../library/form/components/FormLink';
import FormLabel from '../../../library/form/components/FormLabel'
import FormTitle from '../../../library/form/components/FormTitle';
import FormWrapper from '../../../library/form/components/FormWrapper';
import FormStatus from '../../../library/form/components/FormStatus';
import DocFormReview from "../../cmn/docReviewStatus/DocFormReview";
import { UiView, UiViewHeading, UiTitle, UiViewContent, UiGridColOne, UiCol } from "../../../library/layout/Index";

const InvTrnHeader2 = (props) => {
    const { formObject } = props;
    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <FormTitle formObject={formObject} value='Transaction Summary' />
                </UiTitle>
            </UiViewHeading>
            <UiViewContent>
                <UiGridColOne>
                    <UiCol>
                        <ul>   
                            <li> 
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} className='uiVal uiHighlightKey' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docCode" }} value="Document Code" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docCode" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docDate" }} value="Document Date" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docDate" }} className='uiVal' />
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "masterLink" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "masterLink" }} value="Master" />
                                </span>
                                <FormLink formObject={formObject} rowKey="" className="uiLink"
                                    action={{
                                        paramName: "masterLink",
                                        actionId: "show", 
                                        containerKey: "popup"
                                    }}
                                    linkProp={{ target: "_blank" }}
                                ></FormLink>
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "reference" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reference" }} value="Reference" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "reference" }} className='' />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "docStatus" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docstatus" }} value="Document Status" />
                                </span>
                                <FormStatus formObject={formObject} rowKey="" headerKey="docStatus"/>
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "financeStatus" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "financeStatus" }} value="Finance Status" />
                                </span>
                                <FormStatus formObject={formObject} rowKey="" headerKey="finStatus"/>
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "WorkflowStatus" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "WorkflowStatus" }} value="Review Status" />
                                </span>
                                <DocFormReview formObject={formObject} />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "qcStatus" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qcStatus" }} value="QC Status" />
                                </span>
                                <FormStatus formObject={formObject} rowKey="" headerKey="qcStatus"/>
                            </FormWrapper>
                            
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "budgetUsed" }} value="Budget Code" />
                                </span>
                                <FormROValueWithTooltip formObject={formObject} rowKey="" action={{ paramName: "budgetUsed" }} className='uiVal' />
                            </li>

                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "costCenterUsed" }} value="Cost Center" />
                                </span>
                                <FormROValueWithTooltip formObject={formObject} rowKey="" action={{ paramName: "costCenterUsed" }} className='uiVal' />
                            </li>

                        </ul>
                        <FormWrapper customWrapper="ul" formObject={formObject} rowKey="" action={{ paramName: "costContainer" }} >
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                                </span>
                                <FormROValue  formObject={formObject} rowKey="" action={{ paramName: "currency" }} className='uiVal uiHighlightBlue' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "exchangeRate" }} value="Exchange Rate" />
                                </span>
                                <FormROValue  formObject={formObject} rowKey="" action={{ paramName: "exchangeRate" }} className='' />
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "totalAmount" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "totalAmount" }} value="Total Amount" />
                                </span>
                                <FormROValue  formObject={formObject} rowKey="" action={{ paramName: "totalAmount" }}  />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "discount" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "discount" }} value="Discount" />
                                </span>
                                <FormROValue  formObject={formObject} rowKey="" action={{ paramName: "discount" }}  />
                                <FormROValue  formObject={formObject} rowKey="" action={{ paramName: "discountPer" }}  />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "amountDue" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "amountDue" }} value="Amount Due" />
                                </span>
                                <FormROValue  formObject={formObject} rowKey="" action={{ paramName: "amountDue" }} className='uiVal uiHighlightBlue' />
                            </FormWrapper>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taxableAmount" }} value="Taxable Amount" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "taxableAmount" }}  />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "totalTax" }} value="Total Tax" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "totalTax" }}  />
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "deliveryCost" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "deliveryCost" }} value="Delivery Charges" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "deliveryCost" }}  />
                            </FormWrapper>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "amountToPay" }} value="Transaction Value" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "amountToPay" }} className='uiVal uiHighlightBlue' />
                            </li>
                        </FormWrapper>
                    </UiCol>
                </UiGridColOne>
            </UiViewContent>
        </UiView>
    )
}

export default withView(InvTrnHeader2, "invTrnFooter", "invTrnFooter");
